import CardComponent from "./CardComponent";

export class CompanyNameAndReviews extends CardComponent {

}
